<template>
  <div class="table-responsive-sm">
    <div class="row minw-300">
      <div class="col-3 col-lg-4" v-for="(item, key) in avaiableModels" :key="key">
        <div class="curriculo-curriculo" :class="getClassActive(item.id)" @click="changePosition(item.id)">
          <p class="body2 bold color-gray-400 py-3">{{item.name}}</p>
          <img class="mw-100" :src="getImageUrl(item.id)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectModelComponent",
  props: {
    currentPosition: Number,
    avaiableModels: Array,
  },
  computed: {
    currentPositionLocal: {
      get: function () {
        return this.currentPosition;
      },
      set: function (value) {
        this.$emit("update:currentPosition", value);
      },
    },
  },
  methods: {
    getClassActive(idItem) {
      return {active: idItem == this.currentPositionLocal}
    },
    getImageUrl(idItem) {
      return '/static/novomundosenai/imgs/curriculo' + idItem +'.png';
    },
    changePosition(idItem) {
      this.currentPositionLocal = idItem;
    }
  },
};
</script>

<style scoped>
</style>
